import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataTablesModule } from 'angular-datatables';
import { SharedModule } from './shared/shared/shared.module';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    DataTablesModule,
    NoopAnimationsModule,
    NgbModule,
    // RecaptchaModule,
    // RecaptchaFormsModule,
    MatSelectModule,
  ],
  exports: [MatSelectModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
